import React, { useEffect, useState } from 'react'
import AddNewWarehouse from './AddNewWarehouse';

export default function InventoryWarehouse() {
  const [modal, setModal] = useState(false);
  const [editData, setEditData] = useState();
  const [tableData, setTableData] = useState([]);
  const close = () => setModal(!modal);

  useEffect(() => {
    const getWarehouses = async () => {
      const json = {
        outlet_uuid: localStorage.getItem("outlet_uuid"),
      }
      const url = `https://api.myfooddo.com/invWarehouse/ListWarehouse`;
      await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(json),
      })
        .then(res => res.json())
        .then(data => {
          setTableData(data);
        })
        .catch(err => console.warn("post request failed", err));
    }
    getWarehouses();
  }, [modal])

  return (
    <div className="accountGroup">
      <h1>Warehouse</h1>
      <div className="accountGroupOptions">
        <button onClick={() => setModal(!modal)}>+Add New</button>
        <input type="search" placeholder="Search..." />
      </div>

      <div className="items_table" style={{ flex: '1', padding: '0 10px' }}>
        <table className="f6 w-100 center" cellSpacing="0">
          <thead className="lh-copy">
            <tr className="white">
              <th className="pa2 bb b--black-20 w-33">Name</th>
              <th className="pa2 bb b--black-20 w-33">IsPrimary</th>
              <th className="pa2 bb b--black-20 w-33">Action</th>
            </tr>
          </thead>
          <tbody className="lh-copy">
            {tableData.length > 0 && tableData?.map((data, i) => {
              if (data.warehouse_uuid)
                return <tr key={i.toString()}>
                  <td className="ph4 pv1 tc bb b--black-20 bg-white">{data.warehouse_title}</td>
                  <td className="ph4 pv1 tc bb b--black-20 bg-white">{data.is_primary === 'Y' ? 'Yes' : data.is_primary === 'N' ? 'No' : null}</td>
                  <td className="ph4 pv1 tc bb b--black-20 bg-white">
                    <button
                      className='editButton'
                      onClick={() => {
                        setModal(!modal);
                        setEditData(data);
                      }}
                    >Edit</button>
                  </td>
                </tr>
              else return '';
            })}
          </tbody>
        </table>
      </div>

      {modal && (
        <AddNewWarehouse
          type={!editData ? "New" : "Edit"}
          close={close}
          editData={editData}
        />
      )}
    </div>
  )
}
